import { Bus, Stops } from '../bus';

export default {
    parseGPS(latitude, latitudeRef, longitude, longitudeRef) {
        if (!latitude || !longitude) return;
        const lat = this.toDecimal(latitude[0], latitude[1], latitude[2], latitudeRef[3]);
        const long = this.toDecimal(longitude[0], longitude[1], longitude[2], longitudeRef[3]);
        const value = `${lat},${long}`;
        Bus.$emit(Stops.GPS_PARSED, value);
    },
    toDecimal(degrees, minutes, seconds, direction) {
        let value = degrees;
        value += minutes / 60;
        value += seconds / 3600;
        return value * (direction === 'W' || direction === 'S' ? -1 : 1);
    },
};
